var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"info",on:{"click":function($event){return $event.stopPropagation()}}},[_c('span',{staticClass:"info-icon"},[_vm._v("?")]),_c('span',{staticClass:"info-content"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }